<template>
    <div class="examPer">
        <div class="content1">
            <div class="tables">
                <table>
                    <thead>
                        <tr>
                            <td>姓名</td>
                            <td>联系电话</td>
                            <td>关系</td>
                            <td>删除</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(li,index) in users" :key="index" @click="goModify(li)">
                            <td>{{li.NAME}}</td>
                            <td>{{li.PHONE_NUM}}</td>
                            <td>{{li.RELATIONNAME}}</td>
                            <td><i class="iconfont icon-error" @click.stop="delPerson(li)"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="btndiv">
                <button type="button" class="search" @click="search">新增体检人</button>
            </div>
        </div>
    </div>
</template>
<script>
    import api from '@/fetch/api';
    import {
        Dialog,
        Toast
    } from 'vant';
    import {
        mapGetters
    } from 'vuex';
    export default {
        data() {
            return {
                users: []
            }
        },
        methods: {
            queryUser() {
                api.queryUser(this.userInfo.CUSTOMER_ID,this.userInfo.TOKEN).then(re => {
                    this.users = re.data;
                })
            },
            search() {
                this.$router.push({
                    path: '/user/personAdd'
                });
            },
            goModify(item) {
                this.$router.push({
                    path: '/user/personModify/' + item.INDIVIDUAL_ID
                });
            },
            delPerson(item) {
                Dialog.confirm({
                    title: '删除体检人',
                    message: '确定删除吗？'
                }).then(() => {
                    api.deleteUser(item.INDIVIDUAL_ID, this.userInfo.CUSTOMER_ID,this.userInfo.TOKEN).then(re => {
                        if (re.result == true) {
                            Toast.success('删除成功！');
                            this.queryUser();
                        } else {
                            Toast.fail(re.msg);
                        }
                    });
                }).catch(() => {});
            }
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        created() {
            this.queryUser();
        }
    }
</script>
<style lang="less">
    .examPer {
        .content1 {
            .search {
                color: #ffffff;
                background-color: #aacd06;
                box-sizing: border-box;
                border: 1px solid #aacd06; // border-color: rgba(102, 204, 204, 1);
                border-radius: 5px;
                box-shadow: none;
                color: #fff;
                font-size: 0.9rem;
                width: 11em;
                height: 3em;
                text-align: center;
                margin: 3rem 0;
            }
            .btndiv {
                text-align: center;
            }
            padding: 10px;
            .tables {
                border: 0;
                width: 100%;
                padding: 0;
                margin: 0;
                thead td {
                    font-size: 1.2em;
                    color: #99C51D;
                }
                td {
                    height: 1.8em;
                    border-bottom: 1px solid rgb(226, 226, 226);
                    color: #999;
                }
                .iconfont {
                    border: 1px solid #aacd06;
                    border-radius: 5px;
                    font-size: 0.5rem;
                    padding: 0.2rem;
                    color: #fff;
                    background-color: #aacd06;
                    font-weight: bold;
                }
            }
        }
    }
</style>








// WEBPACK FOOTER //
// src/pages/examPerson.vue